import { Box } from '@mui/material'
import { RedLock, Verified } from 'assets/icons'
import i18n from 'i18n'
import { GroupVerified } from 'model/models/Group'
import { GroupDoc } from 'types/api/changes'
import { Model } from 'types/model'
import { isConvertedGroup } from 'utils/api/group_state'
import { removePrefix } from 'utils/object'

interface GroupTitleProps {
  iconHeight?: string
  group?: Model<GroupDoc> | GroupDoc
  align?: string
  locked?: boolean
  weight?: number
}

export default function GroupTitle(props: GroupTitleProps) {
  const shouldShowBadge =
    props.group?.VerifiedGroupStatus &&
    props.group?.VerifiedGroupStatus === GroupVerified.VERIFIED

  let titleWidth = 100

  if (shouldShowBadge) titleWidth -= 10
  if (props.locked) titleWidth -= 10

  return (
    <Box
      fontSize={`${props.iconHeight ?? '16px'} !important`}
      height={'inherit'}
      display={'flex'}
      flexDirection={'row'}
      alignItems={props.align ? props.align : 'center'}
    >
      <Box
        style={{
          fontWeight: props.weight,
          marginRight: 2,
          flex: 1,
          maxWidth: `${titleWidth}%`,
          overflow: 'hidden',
          textAlign: i18n.dir() === 'rtl' ? 'right' : 'left'
        }}
        sx={{
          '@media (max-height: 500px)': {
            marginTop: '6px',
            fontSize: '16px'
          }
        }}
      >
        {isConvertedGroup(props.group)
          ? removePrefix(props.group?.CalendarEmail ?? '')
          : props.group?.Name}
      </Box>
      {shouldShowBadge ? (
        <Verified
          height={props.iconHeight ?? '16px'}
          width={props.iconHeight ?? '16px'}
        />
      ) : (
        <></>
      )}
      {props.locked ? (
        <RedLock
          height={props.iconHeight ?? '16px'}
          width={props.iconHeight ?? '16px'}
        />
      ) : (
        <></>
      )}
    </Box>
  )
}
